"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMakeOfferDto = instanceOfMakeOfferDto;
exports.MakeOfferDtoFromJSON = MakeOfferDtoFromJSON;
exports.MakeOfferDtoFromJSONTyped = MakeOfferDtoFromJSONTyped;
exports.MakeOfferDtoToJSON = MakeOfferDtoToJSON;
exports.MakeOfferDtoToJSONTyped = MakeOfferDtoToJSONTyped;
var MakeOfferCoBuyerDto_1 = require("./MakeOfferCoBuyerDto");
var SubjectToFinanceDto_1 = require("./SubjectToFinanceDto");
/**
 * Check if a given object implements the MakeOfferDto interface.
 */
function instanceOfMakeOfferDto(value) {
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('offerPrice' in value) || value['offerPrice'] === undefined)
        return false;
    if (!('settlementDate' in value) || value['settlementDate'] === undefined)
        return false;
    if (!('offerExpiresAt' in value) || value['offerExpiresAt'] === undefined)
        return false;
    if (!('primaryBuyerName' in value) || value['primaryBuyerName'] === undefined)
        return false;
    if (!('isCounterOffer' in value) || value['isCounterOffer'] === undefined)
        return false;
    return true;
}
function MakeOfferDtoFromJSON(json) {
    return MakeOfferDtoFromJSONTyped(json, false);
}
function MakeOfferDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'listingId': json['listingId'],
        'offerPrice': json['offerPrice'],
        'settlementDate': (new Date(json['settlementDate'])),
        'offerExpiresAt': (new Date(json['offerExpiresAt'])),
        'subjectToFinance': json['subjectToFinance'] == null ? undefined : (0, SubjectToFinanceDto_1.SubjectToFinanceDtoFromJSON)(json['subjectToFinance']),
        'buildingInspectionDate': json['buildingInspectionDate'] == null ? undefined : (new Date(json['buildingInspectionDate'])),
        'conditions': json['conditions'] == null ? undefined : json['conditions'],
        'primaryBuyerName': json['primaryBuyerName'],
        'primaryBuyerEmail': json['primaryBuyerEmail'] == null ? undefined : json['primaryBuyerEmail'],
        'primaryBuyerPhoneNumber': json['primaryBuyerPhoneNumber'] == null ? undefined : json['primaryBuyerPhoneNumber'],
        'coBuyers': json['coBuyers'] == null ? undefined : (json['coBuyers'].map(MakeOfferCoBuyerDto_1.MakeOfferCoBuyerDtoFromJSON)),
        'isCounterOffer': json['isCounterOffer'],
        'parentOfferId': json['parentOfferId'] == null ? undefined : json['parentOfferId'],
        'residentialAddress': json['residentialAddress'] == null ? undefined : json['residentialAddress'],
    };
}
function MakeOfferDtoToJSON(json) {
    return MakeOfferDtoToJSONTyped(json, false);
}
function MakeOfferDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'listingId': value['listingId'],
        'offerPrice': value['offerPrice'],
        'settlementDate': value['settlementDate'].toISOString(),
        'offerExpiresAt': value['offerExpiresAt'].toISOString(),
        'subjectToFinance': (0, SubjectToFinanceDto_1.SubjectToFinanceDtoToJSON)(value['subjectToFinance']),
        'buildingInspectionDate': value['buildingInspectionDate'] == null ? value['buildingInspectionDate'] : value['buildingInspectionDate'].toISOString(),
        'conditions': value['conditions'],
        'primaryBuyerName': value['primaryBuyerName'],
        'primaryBuyerEmail': value['primaryBuyerEmail'],
        'primaryBuyerPhoneNumber': value['primaryBuyerPhoneNumber'],
        'coBuyers': value['coBuyers'] == null ? undefined : (value['coBuyers'].map(MakeOfferCoBuyerDto_1.MakeOfferCoBuyerDtoToJSON)),
        'isCounterOffer': value['isCounterOffer'],
        'parentOfferId': value['parentOfferId'],
        'residentialAddress': value['residentialAddress'],
    };
}
